export default __webpack_public_path__ + "static/media/apple.d02afb90.png";